import * as React from 'react';
import SuperCritical from 'lib/supercritical';

import { BerthLookups } from './model';
import { OrderableLookupsView } from 'portcall/orderablelookups/view';

export const BerthLookupsView = SuperCritical(({ model: m } : { model : BerthLookups }) =>
    <div className="berthlookups pc-page-fixedwidth">
        <div className="pc-actions-links-header">
            <a className="pc-back-link" href="#!siteadminsettings">&lt;&lt; Back to Site Admin Settings</a>
        </div>
        <h1 className="pc-page-title">
            <span className="pc-text-label-color">More</span><span className="pc-icon-bullet pc-text-label-color"></span>
            <span className="pc-text-label-color">Site Admin Settings</span><span className="pc-icon-bullet"></span>
            <span>Berth Lookups</span> 
        </h1>
        <div className="page-body pc-card">
            <PortsView model={m} />
            <CapabilitiesView model={m} />
        </div>
    </div>
);

const PortsView = SuperCritical(({ model: m } : { model : BerthLookups }) => {
    return (
        <div className="ports">
            <h2 className="pc-card-title lookup-section-title">Ports</h2>
            <div className="lookup-description pc-text-smalllabel">
                List and arrange the ports on { m.Model.DisplayableUrl() }. This order will carry throughout the site, 
                such as on the Berths Timeline, and several pages will filter content off of these names. You 
                will add berths to each port on the Manage Berths section. Click and drag a row to reposition 
                it on this list and throughout the site.
            </div>
            <OrderableLookupsView
                model={m.PortLookups}
                columns={[{
                    type: 'textInput',
                    title: 'Name',
                    className: 'name',
                    validationKey: 'Name',
                    itemProp: p => p.Name
                }]}
            />
        </div>
    );
});

const CapabilitiesView = SuperCritical(({ model: m } : { model : BerthLookups }) => {
    return (
        <div className="berthcapabilities">
            <h2 className="pc-card-title lookup-section-title">Capabilities</h2>
            <div className="lookup-description pc-text-smalllabel">
                List the capabilities of all your berths. You will select capabilities from this list 
                on a berth’s profile. The Berths Timeline will filter berths based off these capabilities. 
                Click and drag a row to reposition it on this list and throughout the site.
            </div>
            <OrderableLookupsView
                model={m.CapabilityLookups}
                columns={[{
                    type: 'textInput',
                    title: 'Name',
                    className: 'name',
                    validationKey: 'Name',
                    itemProp: c => c.Name
                }]}
                addBtnText="+Add Capability"
            />
        </div>
    );
});



// WEBPACK FOOTER //
// ./apps/portcall/berthlookups/view.tsx